import React from "react";
import { isMobile } from "../../mobileConfig";

function MobileZone(props) {
  return <>{isMobile() ? props.children : <></>}</>;
}
export default MobileZone;
